import * as ExcelJS from 'exceljs';
import { BaseExcelService } from './baseExcelService';
import { ExcelColors, MultiWithdrawalExportData } from './types';

import dayjs from 'dayjs';
import { TransactionResponse } from '../../model/Transaction.model';

export class WithdrawalExcelService extends BaseExcelService {
  static async exportWithdrawalTransactions(data: MultiWithdrawalExportData) {
    const { records, month, year } = data;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(
      `Giao dịch rút tiền ${month}-${year}`
    );

    // Set column widths
    worksheet.columns = [
      { width: 15 }, // Ngày giao dịch
      { width: 20 }, // Số thẻ
      { width: 25 }, // Chủ thẻ
      { width: 20 }, // Nhân viên
      { width: 15 }, // Thiết bị POS
      { width: 15 }, // Số tiền
      { width: 10 }, // Phí POS
      { width: 15 }, // Số tiền thực nhận
      { width: 15 }, // Trạng thái
    ];

    // Create header
    this.createTableHeader(
      worksheet,
      1,
      [
        'Ngày giao dịch',
        'Số thẻ',
        'Chủ thẻ',
        'Nhân viên thực hiện',
        'Thiết bị POS',
        'Số tiền',
        'Phí POS',
        'Số tiền thực nhận',
        'Trạng thái',
      ],
      ExcelColors.TABLE_HEADER
    );

    // Add data rows
    records.forEach((record: TransactionResponse, index: number) => {
      const row = worksheet.getRow(index + 2);

      // Ngày giao dịch
      const dateCell = row.getCell(1);
      dateCell.value = dayjs(record.transactionDate).format('DD/MM/YYYY');
      this.applyBorder(dateCell);

      // Số thẻ
      const cardCell = row.getCell(2);
      cardCell.value = record.creditCard?.cardNumber;
      this.applyBorder(cardCell);

      // Chủ thẻ
      const holderCell = row.getCell(3);
      holderCell.value = record.creditCard?.cardHolderName;
      this.applyBorder(holderCell);

      // Nhân viên
      const employeeCell = row.getCell(4);
      employeeCell.value = record.employee?.name;
      this.applyBorder(employeeCell);

      // Thiết bị POS
      const posCell = row.getCell(5);
      posCell.value = record.posDevice?.deviceCode;
      this.applyBorder(posCell);

      // Số tiền
      const amountCell = row.getCell(6);
      this.formatCurrencyCell(amountCell, record.amount);

      // Phí POS
      const feeCell = row.getCell(7);
      this.formatPercentageCell(feeCell, record.feeApplied || 0);

      // Số tiền thực nhận
      const balanceCell = row.getCell(8);
      this.formatCurrencyCell(balanceCell, record.balance);

      // Trạng thái
      const statusCell = row.getCell(9);
      statusCell.value =
        record.status === 'COMPLETED' ? 'Đã xác nhận' : 'Chờ xác nhận';
      this.applyBorder(statusCell);
    });

    // Save file
    const fileName = this.generateFileName(
      'Giao dịch rút tiền',
      `${month}_${year}`
    );
    await this.saveExcelFile(workbook, fileName);
  }
}
